import { useBreakpointIndex, Box, getVariant } from '@apia/theme';
import { useMatchScrollDirection } from '@apia/util';
import React from 'react';
import usePortal from 'react-cool-portal';

export const FooterResponsiveButtons = ({
  breakpoint = 4,
  children,
  className,
}: {
  breakpoint?: number;
  children: React.ReactNode;
  className?: string;
}) => {
  const { Portal } = usePortal({
    containerId: 'NonControlledAppModals',
    clickOutsideToHide: false,
    autoRemoveContainer: false,
    defaultShow: true,
    escToHide: false,
  });

  const appBreakpoint = useBreakpointIndex();
  const shouldShow =
    useMatchScrollDirection('down') && breakpoint >= appBreakpoint;

  if (Array.isArray(children) && children.length === 0) return null;

  return (
    <Portal>
      <Box
        as="aside"
        {...getVariant('layout.footerResponsiveButtons')}
        className={`${className ?? ''} ${shouldShow ? 'visible' : 'hidden'}`}
      >
        {children}
      </Box>
    </Portal>
  );
};
